import * as Types from "../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type GatesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GatesQuery = {
  gates: Array<{
    __typename: "Gate";
    id: string;
    buyButtonURL: string | null;
    lockedMessage: string | null;
    name: string;
    createdAt: string | null;
  }>;
};

export type GateQueryVariables = Types.Exact<{
  id: Types.Scalars["String"];
}>;

export type GateQuery = {
  gate: {
    __typename: "Gate";
    id: string;
    name: string;
    conditions: Array<{
      __typename: "Condition";
      amount: number | null;
      autoBuyButton: Types.BuyMarketplace | null;
      buyButtonUrl: string | null;
      required: boolean | null;
      type: Types.ConditionType | null;
      data: {
        __typename: "GenericConditionData";
        address: string | null;
        imageUrl: string | null;
        name: string | null;
        network: Types.NetworkType | null;
        standard: string | null;
        tokenId: string | null;
        allowlist: Array<string> | null;
        allowlistLength: number | null;
        allowlistRaw: string | null;
        email: boolean | null;
        followFID: string | null;
        attributes: Array<{
          __typename: "Attribute";
          key: string;
          value: Array<string>;
        }> | null;
      } | null;
    }> | null;
  };
};

export type GatedEntitiesQueryVariables = Types.Exact<{
  gateId: Types.Scalars["String"];
}>;

export type GatedEntitiesQuery = {
  gatedEntities: Array<
    | {
        __typename: "GatedAuction";
        editionName: string;
        auctionCollectionId: string;
      }
    | {
        __typename: "GatedMintVector";
        collectionId: string | null;
        editionName: string;
      }
    | { __typename: "GatedPage"; slug: string; name: string; pageId: string }
  >;
};

export type GateCreateMutationVariables = Types.Exact<{
  input: Types.GateCreateInput;
}>;

export type GateCreateMutation = {
  gateCreate: { __typename: "Gate"; id: string };
};

export type GateUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars["String"];
  input: Types.GateUpdateInput;
}>;

export type GateUpdateMutation = {
  gateUpdate: { __typename: "Gate"; id: string };
};

export type GateDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars["String"];
}>;

export type GateDeleteMutation = {
  gateDelete: { __typename: "GateDeleteResult"; deletedCount: number };
};

export type CollectionDetailsQueryVariables = Types.Exact<{
  slug: Types.Scalars["String"];
}>;

export type CollectionDetailsQuery = {
  collectionDetails: {
    __typename: "CollectionDetails";
    imageUrl: string | null;
    name: string;
    standard: Types.CollectionStandardType | null;
    description: string | null;
    id: string | null;
    slug: string;
  };
};

export type ContractDetailsQueryVariables = Types.Exact<{
  address: Types.Scalars["String"];
  network: Types.Scalars["String"];
}>;

export type ContractDetailsQuery = {
  contractDetails: {
    __typename: "ContractDetails";
    imageUrl: string | null;
    name: string | null;
    standard: string | null;
    contract: string;
    symbol: string | null;
  };
};

export type CollectionNftsQueryVariables = Types.Exact<{
  slug: Types.Scalars["String"];
  cursor: Types.Maybe<Types.Scalars["String"]>;
}>;

export type CollectionNftsQuery = {
  collectionNftsPaginated: {
    __typename: "CollectionNftsPaginated";
    nfts: Array<{
      __typename: "CollectionNft";
      imageUrl: string | null;
      name: string;
      standard: Types.NftStandardType | null;
      balance: string;
      contract: string;
      id: string;
    }>;
    pageInfo: {
      __typename: "CursorPaginatedInfo";
      endCursor: string | null;
      hasNextPage: boolean;
    };
  };
};

export type ContractNftsQueryVariables = Types.Exact<{
  address: Types.Scalars["String"];
  network: Types.Scalars["String"];
  cursor: Types.Maybe<Types.Scalars["String"]>;
}>;

export type ContractNftsQuery = {
  contractNftsPaginated: {
    __typename: "ContractNftsPaginated";
    nfts: Array<{
      __typename: "ContractNft";
      imageUrl: string | null;
      name: string;
      standard: string | null;
      backgroundColor: string | null;
      balance: string;
      contract: string;
      description: string | null;
      externalUrl: string | null;
      id: string;
      uri: string | null;
    }>;
    pageInfo: {
      __typename: "CursorPaginatedInfo";
      endCursor: string | null;
      hasNextPage: boolean;
    };
  };
};

export type WalletNftsQueryVariables = Types.Exact<{
  address: Types.Scalars["String"];
  first: Types.Scalars["Float"];
  after: Types.Maybe<Types.Scalars["String"]>;
}>;

export type WalletNftsQuery = {
  walletNftsPaginated: {
    __typename: "WalletNftsPaginated";
    walletNfts: Array<{
      __typename: "WalletNft";
      id: string;
      name: string;
      contract: string;
      chain: string;
      standard: string | null;
      imageUrl: string | null;
      videoUrl: string | null;
      attributes: Array<{
        __typename: "Attribute";
        key: string;
        value: Array<string>;
      }> | null;
    }>;
    pageInfo: {
      __typename: "CursorPaginatedInfo";
      endCursor: string | null;
      hasNextPage: boolean;
    };
  };
};

export type CollectionNftQueryVariables = Types.Exact<{
  collectionNftId: Types.Scalars["String"];
  slug: Types.Scalars["String"];
}>;

export type CollectionNftQuery = {
  collectionNft: {
    __typename: "CollectionNft";
    balance: string;
    contract: string;
    id: string;
    imageUrl: string | null;
    name: string;
    standard: Types.NftStandardType | null;
  };
};

export type CurrencyDetailsQueryVariables = Types.Exact<{
  address: Types.Scalars["String"];
  network: Types.Scalars["String"];
}>;

export type CurrencyDetailsQuery = {
  currencyDetails: {
    __typename: "CurrencyDetails";
    contract: string;
    imageUrl: string | null;
    name: string | null;
    standard: Types.CurrencyStandardType | null;
    symbol: string | null;
  };
};

export type ContractNftQueryVariables = Types.Exact<{
  contractNftId: Types.Scalars["String"];
  address: Types.Scalars["String"];
  network: Types.Scalars["String"];
}>;

export type ContractNftQuery = {
  contractNft: {
    __typename: "ContractNft";
    backgroundColor: string | null;
    balance: string;
    contract: string;
    description: string | null;
    externalUrl: string | null;
    id: string;
    imageUrl: string | null;
    videoUrl: string | null;
    name: string;
    standard: string | null;
    uri: string | null;
    attributes: Array<{
      __typename: "Attribute";
      key: string;
      value: Array<string>;
    }> | null;
  };
};

export type CollectionAttributesQueryVariables = Types.Exact<{
  slug: Types.Scalars["String"];
}>;

export type CollectionAttributesQuery = {
  collectionAttributes: {
    __typename: "CollectionAttributes";
    attributes: Array<{
      __typename: "Attribute";
      key: string;
      value: Array<string>;
    }>;
  };
};

export type ContractAttributesQueryVariables = Types.Exact<{
  network: Types.Scalars["String"];
  address: Types.Scalars["String"];
}>;

export type ContractAttributesQuery = {
  contractAttributes: {
    __typename: "ContractAttributes";
    contract: string;
    attributes: Array<{
      __typename: "Attribute";
      key: string;
      value: Array<string>;
    }>;
  };
};

export const GatesDocument = gql`
  query Gates {
    gates {
      id
      buyButtonURL
      lockedMessage
      name
      createdAt
    }
  }
`;

/**
 * __useGatesQuery__
 *
 * To run a query within a React component, call `useGatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGatesQuery(
  baseOptions?: Apollo.QueryHookOptions<GatesQuery, GatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GatesQuery, GatesQueryVariables>(
    GatesDocument,
    options
  );
}
export function useGatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GatesQuery, GatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GatesQuery, GatesQueryVariables>(
    GatesDocument,
    options
  );
}
export type GatesQueryHookResult = ReturnType<typeof useGatesQuery>;
export type GatesLazyQueryHookResult = ReturnType<typeof useGatesLazyQuery>;
export type GatesQueryResult = Apollo.QueryResult<
  GatesQuery,
  GatesQueryVariables
>;
export const GateDocument = gql`
  query Gate($id: String!) {
    gate(id: $id) {
      id
      name
      conditions {
        amount
        autoBuyButton
        buyButtonUrl
        required
        type
        data {
          address
          imageUrl
          name
          network
          standard
          tokenId
          allowlist
          allowlistLength
          allowlistRaw
          attributes {
            key
            value
          }
          email
          followFID
        }
      }
    }
  }
`;

/**
 * __useGateQuery__
 *
 * To run a query within a React component, call `useGateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateQuery(
  baseOptions: Apollo.QueryHookOptions<GateQuery, GateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GateQuery, GateQueryVariables>(GateDocument, options);
}
export function useGateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GateQuery, GateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GateQuery, GateQueryVariables>(
    GateDocument,
    options
  );
}
export type GateQueryHookResult = ReturnType<typeof useGateQuery>;
export type GateLazyQueryHookResult = ReturnType<typeof useGateLazyQuery>;
export type GateQueryResult = Apollo.QueryResult<GateQuery, GateQueryVariables>;
export const GatedEntitiesDocument = gql`
  query GatedEntities($gateId: String!) {
    gatedEntities(gateId: $gateId) {
      ... on GatedPage {
        pageId: id
        slug
        name
      }
      ... on GatedMintVector {
        collectionId
        editionName
      }
      ... on GatedAuction {
        auctionCollectionId: collectionId
        editionName
      }
    }
  }
`;

/**
 * __useGatedEntitiesQuery__
 *
 * To run a query within a React component, call `useGatedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatedEntitiesQuery({
 *   variables: {
 *      gateId: // value for 'gateId'
 *   },
 * });
 */
export function useGatedEntitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GatedEntitiesQuery,
    GatedEntitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GatedEntitiesQuery, GatedEntitiesQueryVariables>(
    GatedEntitiesDocument,
    options
  );
}
export function useGatedEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GatedEntitiesQuery,
    GatedEntitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GatedEntitiesQuery, GatedEntitiesQueryVariables>(
    GatedEntitiesDocument,
    options
  );
}
export type GatedEntitiesQueryHookResult = ReturnType<
  typeof useGatedEntitiesQuery
>;
export type GatedEntitiesLazyQueryHookResult = ReturnType<
  typeof useGatedEntitiesLazyQuery
>;
export type GatedEntitiesQueryResult = Apollo.QueryResult<
  GatedEntitiesQuery,
  GatedEntitiesQueryVariables
>;
export const GateCreateDocument = gql`
  mutation GateCreate($input: GateCreateInput!) {
    gateCreate(input: $input) {
      id
    }
  }
`;
export type GateCreateMutationFn = Apollo.MutationFunction<
  GateCreateMutation,
  GateCreateMutationVariables
>;

/**
 * __useGateCreateMutation__
 *
 * To run a mutation, you first call `useGateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateCreateMutation, { data, loading, error }] = useGateCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGateCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GateCreateMutation,
    GateCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GateCreateMutation, GateCreateMutationVariables>(
    GateCreateDocument,
    options
  );
}
export type GateCreateMutationHookResult = ReturnType<
  typeof useGateCreateMutation
>;
export type GateCreateMutationResult =
  Apollo.MutationResult<GateCreateMutation>;
export type GateCreateMutationOptions = Apollo.BaseMutationOptions<
  GateCreateMutation,
  GateCreateMutationVariables
>;
export const GateUpdateDocument = gql`
  mutation GateUpdate($id: String!, $input: GateUpdateInput!) {
    gateUpdate(id: $id, input: $input) {
      id
    }
  }
`;
export type GateUpdateMutationFn = Apollo.MutationFunction<
  GateUpdateMutation,
  GateUpdateMutationVariables
>;

/**
 * __useGateUpdateMutation__
 *
 * To run a mutation, you first call `useGateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateUpdateMutation, { data, loading, error }] = useGateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGateUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GateUpdateMutation,
    GateUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GateUpdateMutation, GateUpdateMutationVariables>(
    GateUpdateDocument,
    options
  );
}
export type GateUpdateMutationHookResult = ReturnType<
  typeof useGateUpdateMutation
>;
export type GateUpdateMutationResult =
  Apollo.MutationResult<GateUpdateMutation>;
export type GateUpdateMutationOptions = Apollo.BaseMutationOptions<
  GateUpdateMutation,
  GateUpdateMutationVariables
>;
export const GateDeleteDocument = gql`
  mutation GateDelete($id: String!) {
    gateDelete(id: $id) {
      deletedCount
    }
  }
`;
export type GateDeleteMutationFn = Apollo.MutationFunction<
  GateDeleteMutation,
  GateDeleteMutationVariables
>;

/**
 * __useGateDeleteMutation__
 *
 * To run a mutation, you first call `useGateDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGateDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gateDeleteMutation, { data, loading, error }] = useGateDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGateDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GateDeleteMutation,
    GateDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GateDeleteMutation, GateDeleteMutationVariables>(
    GateDeleteDocument,
    options
  );
}
export type GateDeleteMutationHookResult = ReturnType<
  typeof useGateDeleteMutation
>;
export type GateDeleteMutationResult =
  Apollo.MutationResult<GateDeleteMutation>;
export type GateDeleteMutationOptions = Apollo.BaseMutationOptions<
  GateDeleteMutation,
  GateDeleteMutationVariables
>;
export const CollectionDetailsDocument = gql`
  query CollectionDetails($slug: String!) {
    collectionDetails(slug: $slug) {
      imageUrl
      name
      standard
      description
      id
      slug
    }
  }
`;

/**
 * __useCollectionDetailsQuery__
 *
 * To run a query within a React component, call `useCollectionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCollectionDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionDetailsQuery,
    CollectionDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollectionDetailsQuery,
    CollectionDetailsQueryVariables
  >(CollectionDetailsDocument, options);
}
export function useCollectionDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionDetailsQuery,
    CollectionDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionDetailsQuery,
    CollectionDetailsQueryVariables
  >(CollectionDetailsDocument, options);
}
export type CollectionDetailsQueryHookResult = ReturnType<
  typeof useCollectionDetailsQuery
>;
export type CollectionDetailsLazyQueryHookResult = ReturnType<
  typeof useCollectionDetailsLazyQuery
>;
export type CollectionDetailsQueryResult = Apollo.QueryResult<
  CollectionDetailsQuery,
  CollectionDetailsQueryVariables
>;
export const ContractDetailsDocument = gql`
  query ContractDetails($address: String!, $network: String!) {
    contractDetails(address: $address, network: $network) {
      imageUrl
      name
      standard
      contract
      symbol
    }
  }
`;

/**
 * __useContractDetailsQuery__
 *
 * To run a query within a React component, call `useContractDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetailsQuery({
 *   variables: {
 *      address: // value for 'address'
 *      network: // value for 'network'
 *   },
 * });
 */
export function useContractDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContractDetailsQuery,
    ContractDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContractDetailsQuery, ContractDetailsQueryVariables>(
    ContractDetailsDocument,
    options
  );
}
export function useContractDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContractDetailsQuery,
    ContractDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ContractDetailsQuery,
    ContractDetailsQueryVariables
  >(ContractDetailsDocument, options);
}
export type ContractDetailsQueryHookResult = ReturnType<
  typeof useContractDetailsQuery
>;
export type ContractDetailsLazyQueryHookResult = ReturnType<
  typeof useContractDetailsLazyQuery
>;
export type ContractDetailsQueryResult = Apollo.QueryResult<
  ContractDetailsQuery,
  ContractDetailsQueryVariables
>;
export const CollectionNftsDocument = gql`
  query CollectionNfts($slug: String!, $cursor: String) {
    collectionNftsPaginated(slug: $slug, first: 9, after: $cursor) {
      nfts {
        imageUrl
        name
        standard
        balance
        contract
        id
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useCollectionNftsQuery__
 *
 * To run a query within a React component, call `useCollectionNftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionNftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionNftsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCollectionNftsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionNftsQuery,
    CollectionNftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionNftsQuery, CollectionNftsQueryVariables>(
    CollectionNftsDocument,
    options
  );
}
export function useCollectionNftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionNftsQuery,
    CollectionNftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CollectionNftsQuery, CollectionNftsQueryVariables>(
    CollectionNftsDocument,
    options
  );
}
export type CollectionNftsQueryHookResult = ReturnType<
  typeof useCollectionNftsQuery
>;
export type CollectionNftsLazyQueryHookResult = ReturnType<
  typeof useCollectionNftsLazyQuery
>;
export type CollectionNftsQueryResult = Apollo.QueryResult<
  CollectionNftsQuery,
  CollectionNftsQueryVariables
>;
export const ContractNftsDocument = gql`
  query ContractNfts($address: String!, $network: String!, $cursor: String) {
    contractNftsPaginated(
      address: $address
      network: $network
      first: 9
      after: $cursor
    ) {
      nfts {
        imageUrl
        name
        standard
        backgroundColor
        balance
        contract
        description
        externalUrl
        id
        uri
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useContractNftsQuery__
 *
 * To run a query within a React component, call `useContractNftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractNftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractNftsQuery({
 *   variables: {
 *      address: // value for 'address'
 *      network: // value for 'network'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useContractNftsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContractNftsQuery,
    ContractNftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContractNftsQuery, ContractNftsQueryVariables>(
    ContractNftsDocument,
    options
  );
}
export function useContractNftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContractNftsQuery,
    ContractNftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContractNftsQuery, ContractNftsQueryVariables>(
    ContractNftsDocument,
    options
  );
}
export type ContractNftsQueryHookResult = ReturnType<
  typeof useContractNftsQuery
>;
export type ContractNftsLazyQueryHookResult = ReturnType<
  typeof useContractNftsLazyQuery
>;
export type ContractNftsQueryResult = Apollo.QueryResult<
  ContractNftsQuery,
  ContractNftsQueryVariables
>;
export const WalletNftsDocument = gql`
  query WalletNfts($address: String!, $first: Float!, $after: String) {
    walletNftsPaginated(address: $address, first: $first, after: $after) {
      walletNfts {
        id
        name
        contract
        chain
        standard
        imageUrl
        videoUrl
        attributes {
          key
          value
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useWalletNftsQuery__
 *
 * To run a query within a React component, call `useWalletNftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletNftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletNftsQuery({
 *   variables: {
 *      address: // value for 'address'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useWalletNftsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WalletNftsQuery,
    WalletNftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WalletNftsQuery, WalletNftsQueryVariables>(
    WalletNftsDocument,
    options
  );
}
export function useWalletNftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WalletNftsQuery,
    WalletNftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WalletNftsQuery, WalletNftsQueryVariables>(
    WalletNftsDocument,
    options
  );
}
export type WalletNftsQueryHookResult = ReturnType<typeof useWalletNftsQuery>;
export type WalletNftsLazyQueryHookResult = ReturnType<
  typeof useWalletNftsLazyQuery
>;
export type WalletNftsQueryResult = Apollo.QueryResult<
  WalletNftsQuery,
  WalletNftsQueryVariables
>;
export const CollectionNftDocument = gql`
  query CollectionNft($collectionNftId: String!, $slug: String!) {
    collectionNft(id: $collectionNftId, slug: $slug) {
      balance
      contract
      id
      imageUrl
      name
      standard
    }
  }
`;

/**
 * __useCollectionNftQuery__
 *
 * To run a query within a React component, call `useCollectionNftQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionNftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionNftQuery({
 *   variables: {
 *      collectionNftId: // value for 'collectionNftId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCollectionNftQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionNftQuery,
    CollectionNftQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionNftQuery, CollectionNftQueryVariables>(
    CollectionNftDocument,
    options
  );
}
export function useCollectionNftLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionNftQuery,
    CollectionNftQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CollectionNftQuery, CollectionNftQueryVariables>(
    CollectionNftDocument,
    options
  );
}
export type CollectionNftQueryHookResult = ReturnType<
  typeof useCollectionNftQuery
>;
export type CollectionNftLazyQueryHookResult = ReturnType<
  typeof useCollectionNftLazyQuery
>;
export type CollectionNftQueryResult = Apollo.QueryResult<
  CollectionNftQuery,
  CollectionNftQueryVariables
>;
export const CurrencyDetailsDocument = gql`
  query CurrencyDetails($address: String!, $network: String!) {
    currencyDetails(address: $address, network: $network) {
      contract
      imageUrl
      name
      standard
      symbol
    }
  }
`;

/**
 * __useCurrencyDetailsQuery__
 *
 * To run a query within a React component, call `useCurrencyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyDetailsQuery({
 *   variables: {
 *      address: // value for 'address'
 *      network: // value for 'network'
 *   },
 * });
 */
export function useCurrencyDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CurrencyDetailsQuery,
    CurrencyDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrencyDetailsQuery, CurrencyDetailsQueryVariables>(
    CurrencyDetailsDocument,
    options
  );
}
export function useCurrencyDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrencyDetailsQuery,
    CurrencyDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CurrencyDetailsQuery,
    CurrencyDetailsQueryVariables
  >(CurrencyDetailsDocument, options);
}
export type CurrencyDetailsQueryHookResult = ReturnType<
  typeof useCurrencyDetailsQuery
>;
export type CurrencyDetailsLazyQueryHookResult = ReturnType<
  typeof useCurrencyDetailsLazyQuery
>;
export type CurrencyDetailsQueryResult = Apollo.QueryResult<
  CurrencyDetailsQuery,
  CurrencyDetailsQueryVariables
>;
export const ContractNftDocument = gql`
  query ContractNft(
    $contractNftId: String!
    $address: String!
    $network: String!
  ) {
    contractNft(id: $contractNftId, address: $address, network: $network) {
      backgroundColor
      attributes {
        key
        value
      }
      balance
      contract
      description
      externalUrl
      id
      imageUrl
      videoUrl
      name
      standard
      uri
    }
  }
`;

/**
 * __useContractNftQuery__
 *
 * To run a query within a React component, call `useContractNftQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractNftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractNftQuery({
 *   variables: {
 *      contractNftId: // value for 'contractNftId'
 *      address: // value for 'address'
 *      network: // value for 'network'
 *   },
 * });
 */
export function useContractNftQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContractNftQuery,
    ContractNftQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ContractNftQuery, ContractNftQueryVariables>(
    ContractNftDocument,
    options
  );
}
export function useContractNftLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContractNftQuery,
    ContractNftQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ContractNftQuery, ContractNftQueryVariables>(
    ContractNftDocument,
    options
  );
}
export type ContractNftQueryHookResult = ReturnType<typeof useContractNftQuery>;
export type ContractNftLazyQueryHookResult = ReturnType<
  typeof useContractNftLazyQuery
>;
export type ContractNftQueryResult = Apollo.QueryResult<
  ContractNftQuery,
  ContractNftQueryVariables
>;
export const CollectionAttributesDocument = gql`
  query CollectionAttributes($slug: String!) {
    collectionAttributes(slug: $slug) {
      attributes {
        key
        value
      }
    }
  }
`;

/**
 * __useCollectionAttributesQuery__
 *
 * To run a query within a React component, call `useCollectionAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionAttributesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCollectionAttributesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionAttributesQuery,
    CollectionAttributesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollectionAttributesQuery,
    CollectionAttributesQueryVariables
  >(CollectionAttributesDocument, options);
}
export function useCollectionAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionAttributesQuery,
    CollectionAttributesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionAttributesQuery,
    CollectionAttributesQueryVariables
  >(CollectionAttributesDocument, options);
}
export type CollectionAttributesQueryHookResult = ReturnType<
  typeof useCollectionAttributesQuery
>;
export type CollectionAttributesLazyQueryHookResult = ReturnType<
  typeof useCollectionAttributesLazyQuery
>;
export type CollectionAttributesQueryResult = Apollo.QueryResult<
  CollectionAttributesQuery,
  CollectionAttributesQueryVariables
>;
export const ContractAttributesDocument = gql`
  query ContractAttributes($network: String!, $address: String!) {
    contractAttributes(network: $network, address: $address) {
      contract
      attributes {
        key
        value
      }
    }
  }
`;

/**
 * __useContractAttributesQuery__
 *
 * To run a query within a React component, call `useContractAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractAttributesQuery({
 *   variables: {
 *      network: // value for 'network'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useContractAttributesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContractAttributesQuery,
    ContractAttributesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ContractAttributesQuery,
    ContractAttributesQueryVariables
  >(ContractAttributesDocument, options);
}
export function useContractAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContractAttributesQuery,
    ContractAttributesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ContractAttributesQuery,
    ContractAttributesQueryVariables
  >(ContractAttributesDocument, options);
}
export type ContractAttributesQueryHookResult = ReturnType<
  typeof useContractAttributesQuery
>;
export type ContractAttributesLazyQueryHookResult = ReturnType<
  typeof useContractAttributesLazyQuery
>;
export type ContractAttributesQueryResult = Apollo.QueryResult<
  ContractAttributesQuery,
  ContractAttributesQueryVariables
>;
